import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import afbe53e7a2bdfbaf50b92218b12c0a7e7b from "./generated-1f658a60-ed6e-49b1-89b6-300e390e2991.json";

import aa7933e1f155f8d77075172ec8a40e14cb from "./generated-5f5601d0-f1b6-49ad-aef0-7175db5b8bd3.json";

import aa1c5bb55133a837712d3b397b4f1b5d6b from "./generated-c2b25be7-fcc1-434f-97b8-a3f162bcf269.json";

import a6a253717e3cd5b86f51c7741ddeeb3dcb from "./generated-e7fc6f6e-c961-46fc-b7a4-0c0af10cda2e.json";

import acbe92828f9e271a88791dc4ae5bcec46b from "./generated-f12e8dff-b840-4d6b-a2cb-1e363c4e6132.json";

import af18148ef5f5f272da857b7718b580a33b from "./generated-ac5a9e81-570c-4053-b80c-81f4106f6c77.json";

import a665f39d889e67a745bdb0c9fef873beab from "./generated-f53e4064-5ad8-4d94-9286-f4849cc3cf84.json";

import a6b371a5a4caed19c6217f1812ca87006b from "./generated-a2ac9082-8dab-4852-9d6f-6117bd5fbf6b.json";

import a414de4edb46315da6c81107b3c2eea01b from "./generated-3181e59e-ff82-4d56-a73e-d6ef54a7a7b4.json";

import aa9e6c5f2729e28f6de35bed5a9a43f54b from "./generated-e4dc7d4c-a299-45ef-b9ac-cb1a9c6e9411.json";

import ae475e96a047e9c1cb8797826bfa63d87b from "./generated-abf377bc-5015-4a40-834c-5c7bbf80d0d2.json";

import a6aab06107d39318206338f6772b9cdb9b from "./generated-21651888-7b5d-42bf-9a1a-6fceace5a5ab.json";

import a3947cdf64044f9b75aecadb639363f27b from "./generated-f4fc7ad3-3756-4ea1-9485-b3649d436069.json";

import a6bf1a18d4a8c4283b00a73f5f0aea5e2b from "./generated-3e62a09f-4af9-4a0c-940a-65759bc63fbf.json";

import ad31ce491d206088fdb67937df24e8273b from "./generated-16e0c11c-8062-4c9c-a040-7cac19020687.json";

import ad66ea908a72242ba069b02f800e184bbb from "./generated-ec87521e-20bb-4871-a642-947f8cee83b5.json";

import aaeff7b1c581142790284640527dfbc73b from "./generated-20265d48-41be-4ebd-8f85-995455bc09af.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(afbe53e7a2bdfbaf50b92218b12c0a7e7b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aa7933e1f155f8d77075172ec8a40e14cb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(aa1c5bb55133a837712d3b397b4f1b5d6b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a6a253717e3cd5b86f51c7741ddeeb3dcb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(acbe92828f9e271a88791dc4ae5bcec46b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(af18148ef5f5f272da857b7718b580a33b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a665f39d889e67a745bdb0c9fef873beab);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a6b371a5a4caed19c6217f1812ca87006b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a414de4edb46315da6c81107b3c2eea01b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(aa9e6c5f2729e28f6de35bed5a9a43f54b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ae475e96a047e9c1cb8797826bfa63d87b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a6aab06107d39318206338f6772b9cdb9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a414de4edb46315da6c81107b3c2eea01b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a3947cdf64044f9b75aecadb639363f27b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a6bf1a18d4a8c4283b00a73f5f0aea5e2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a414de4edb46315da6c81107b3c2eea01b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ad31ce491d206088fdb67937df24e8273b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ad66ea908a72242ba069b02f800e184bbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(aaeff7b1c581142790284640527dfbc73b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ad31ce491d206088fdb67937df24e8273b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */